import React, { useMemo, useState } from "react";
import CardMenu from "components/card/CardMenu";
import Card from "components/card";

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { MdDelete, MdDeleteForever, MdEdit } from "react-icons/md";
import { IoMdEye } from "react-icons/io";


function TransectionTable({ tableData, title, deleteSubAdmin }) {
  const [openAdminModal, setOpenAdminModal] = useState(false);
  const [singleData, setSingleData] = useState({});
  const [sorting, setSorting] = useState([]);


  // ✅ Use direct data without memo
  const data = Array.isArray(tableData) ? tableData : [];

  // ✅ Define columns directly (no useMemo)
 const columns = [
  columnHelper.accessor("order_id", {
    id: "order_id",
    header: "Order ID",
    cell: (info) => info.getValue() || "N/A",
  }),
  columnHelper.accessor("userName", {
    id: "userName",
    header: "User Name",
    cell: (info) => info.getValue() || "N/A",
  }),
  columnHelper.accessor("userEmail", {
    id: "userEmail",
    header: "User Email",
    cell: (info) => info.getValue() || "N/A",
  }),
  columnHelper.accessor("appId", {
    id: "appId",
    header: "App ID",
    cell: (info) => info.getValue() || "N/A",
  }),
  columnHelper.accessor("amount", {
    id: "amount",
    header: "Amount",
    cell: (info) => `₹${info.getValue()}`,
  }),
  columnHelper.accessor("mode", {
    id: "mode",
    header: "Mode",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("status", {
    id: "status",
    header: "Status",
    cell: (info) => (
      <span
        className={`px-2 py-1 rounded-full text-xs font-semibold ${
          info.getValue() === "pending"
            ? "bg-yellow-200 text-yellow-800"
            : info.getValue() === "success"
            ? "bg-green-200 text-green-800"
            : "bg-red-200 text-red-800"
        }`}
      >
        {info.getValue()}
      </span>
    ),
  }),
  columnHelper.accessor("createdAt", {
    id: "createdAt",
    header: "Created At",
    cell: (info) => new Date(info.getValue()).toLocaleDateString(),
  }),
   columnHelper.accessor("action", {
      id: "action",
      header: () => (
        <span className="text-sm font-bold text-gray-600 dark:text-white">ACTION</span>
      ),
      cell: (info) => {
        const rowData = info.row.original;
        console.log("hello",rowData)
        return (
          <div className="flex items-center gap-2 text-sm font-bold text-navy-700 dark:text-white">
            {/* <MdEdit
              className="cursor-pointer"
              onClick={() => {
                setSingleData(rowData);
                setOpenAdminModal(true);
              }}
            /> */}
           {/* {rowData?.isDeleted !==true ?   <MdDelete
                         className="cursor-pointer"
                         onClick={() => deleteSubAdmin(rowData._id)}
                       />
                       :<MdDeleteForever />} */}
            {rowData?._id ? (
              <a href={`/admin/transection-details/${rowData._id}`}>
                <IoMdEye className="cursor-pointer" />
              </a>
            ) : (
              <span>Not available</span>
            )}
          </div>
        );
      },
    }),
];


  // ✅ Setup react-table
  const table = useReactTable({
    data,
    columns,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getRowId: row => row._id || row.appID || row.email || Math.random().toString(),
  });

  // ✅ No memo, slice directly in render
  const visibleRows = table.getRowModel().rows.slice(0, 5);

  return (
    <Card extra="w-full pb-10 p-4 h-full">
      <header className="relative flex items-center justify-between">
        <div className="text-xl font-bold text-navy-700 dark:text-white">{title}</div>
      
      </header>

      <div className="mt-8 overflow-x-auto">
        <table className="w-full">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    colSpan={header.colSpan}
                    onClick={header.column.getToggleSortingHandler()}
                    className="cursor-pointer border-b border-gray-200 pt-4 pb-2 pr-4 text-start"
                  >
                    <div className="flex items-center justify-between text-xs text-gray-600 dark:text-white">
                      {flexRender(header.column.columnDef.header, header.getContext())}
                      {{
                        asc: " 🔼",
                        desc: " 🔽",
                      }[header.column.getIsSorted()] ?? null}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {visibleRows.map((row) => (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <td
                    key={cell.id}
                    className="min-w-[150px] py-3 pr-4 text-sm text-navy-700 dark:text-white"
                  >
                    <div>{flexRender(cell.column.columnDef.cell, cell.getContext())}</div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}



export default TransectionTable;
const columnHelper = createColumnHelper();
